
import { useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import UsuarioService, { UsuarioInput, getCategoriaIndexByName } from '../../../services/UsuarioService';
import Voltar from '../../../components/voltar/voltar';
import UsuarioForm from '../usuario-formulario/usuario-formulario';
import ErroDeNegocio from '../../../errors/ErroDeNegocio';
import useAppFeedback from '../../../hooks/use-app-feedback';
import Modal from '../../../components/modal/modal';
import Button from '../../../components/button/button';

import './usuario-criacao.css';
import SessaoUsuarioContext from '../../../contexts/SessaoUsuarioContext';


const UsuarioCriacao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { adicionarFeedbackDeErro, limparFeedbacks } = useAppFeedback();
  const [isOpened, setIsOpened] = useState(false);
  const { sessao } = useContext(SessaoUsuarioContext);
  const criaNovoUsuario = useCallback((async (usuario: UsuarioInput): Promise<boolean> => {

    limparFeedbacks();
    setLoading(true)
    let result = true;

    if (sessao?.validaAreasOrganizacionais
      && usuario.statusModulos.pessoal === true
      && usuario.areaLiberadas.length === 0) {
      setIsOpened(true);
      setLoading(false);
      return false;
    }

    try {
      await UsuarioService.salvarUsuario({
        ...usuario,
        categoria: getCategoriaIndexByName(usuario.categoria),
      });
      navigate('/usuario', { state: { result: 'Usuário criado com sucesso' } });
    } catch (error) {
      const message = (error as ErroDeNegocio)?.mensagem || (error as Error).message;
      adicionarFeedbackDeErro(message);
      result = false;
    }
    setLoading(false)
    return result;
  }), [adicionarFeedbackDeErro, limparFeedbacks, navigate, sessao?.validaAreasOrganizacionais])

  const voltar = useCallback(() => {
    limparFeedbacks();
    navigate('/usuario')
  }, [limparFeedbacks, navigate]);

  return (
    <>
      <h1 className="top-title"><Voltar caminho='usuario' />Novo Usuario</h1>
      <UsuarioForm
        loading={loading}
        titulo='Novo Usuario'
        acao={{
          onClickAcao: criaNovoUsuario,
          texto: "Criar Usuario"
        }}
        cancelarAcao={{
          onClickCancelaAcao: voltar,
          texto: 'Cancelar'
        }}
      />
      <Modal 
        isOpened={isOpened}
        classes='modal_criacao'>
        <>
          <div className="notificacao">
            <h2><strong>Quase lá.</strong></h2>
            <h4 className="h4">                               
              Escolha quais painéis e áreas este usuário poderá  <br />  
              visualizar em “definir acesso” no Módulo Pessoal para <br /> 
              garantir a segurança dos dados.<br />  <br /> 
            </h4>
            <Button  
              classes='formulario__button'
              text="Entendi" onClick={() => setIsOpened(false)} />
          </div>
        </>
      </Modal>
    </>
  );
}
export default UsuarioCriacao;

